/**
 * Total message count (user + assistant) at which the inline "this conversation
 * is getting long" notice appears in the AI chat panel. Exported so tests and
 * the consuming component share a single source of truth.
 */
export const LONG_CONVERSATION_THRESHOLD = 15;

/**
 * Hard cap (FUN-4637): the server only ever sends the most recent N non-system
 * messages to the model, regardless of how long the persisted transcript is.
 * Bounds token cost / latency. The full history still lives in Postgres.
 */
export const HARD_CONVERSATION_MESSAGE_CAP = 30;

/**
 * Pure predicate — the notice is a function of message count only. Hidden on
 * an empty thread to avoid an empty-state flash.
 */
export function shouldShowLongConversationNotice(messageCount: number): boolean {
    if (messageCount <= 0) return false;
    return messageCount >= LONG_CONVERSATION_THRESHOLD;
}
